<template>
    <div v-show="addDistressImage">
        <div class="tools_headding catgory_headding w-100 add_txt heading-pd">
            <h4 class="heading5">Choose Effect</h4>
            <a
                href="javascript:;"
                @click="closeImageList()"
                title="Close"
                class="ml-auto"
            >
                <img src="/maincss/images/tool_close.svg" alt="" />
            </a>
        </div>
        <div class="checkbox_div mr_10">
            <input
                type="checkbox"
                id="distress"
                required="required"
                class="mr_6"
                v-model="checked"
                @click="hidecont()"
            />
            <span for="html">Distress</span>
        </div>
        <div v-show="checked">
            <div class="categorys_open mt_14 shape_open">
                <div
                    id="avatarlist"
                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                >
                    <div
                        class="form-check pl-0 img-polaroid add_shap_pd_des"
                        v-for="(distressImage, index) in distress_Image_list"
                        :key="index"
                    >
                        <label class="checkbox_custom brand_logo_select">
                            <img
                                v-tooltip="distressImage.name"
                                :src="distressImage.filter_image_url"
                                :alt="'Image not found'"
                            />
                            <input
                                type="radio"
                                name="distress_image"
                                @click="setValue(distressImage.image_url)"
                                :checked="
                                    selectedDistressImage ==
                                    distressImage.image_url
                                "
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
export default {
    name: "DistressImageList",
    props: [
        "addDistressImage",
        "showImageList",
        "canvasActiveObj",
        "value",
        "number",
        "selectedDistressImage"
    ],

    data: () => {
        return {
            selectedColor: undefined,
            product_data: [],
            distress_Image_list: [],
            apiurl: ApiService.apiUrl(),
            checked: false
        };
    },
    mounted() {
        this.getDistressImages();
    },

    methods: {
        closeImageList() {
            this.$emit("closeImageList");
        },
        setValue(e) {
            if (this.selectedDistressImage == e) {
                this.$emit("set-value", "");
            } else {
                this.$emit("set-value", e);
            }
            this.$emit("undoAndRedo");
        },
        hidecont() {
            this.checked = !this.checked;
            if (!this.checked) {
                this.$emit("set-value", "");
            }
        },
        getDistressImages() {
            //get all distress images
            var _this = this;
            new Promise(() => {
                ApiService.get("/get-all-distress-images")
                    .then(({ data }) => {
                        _this.distress_Image_list = data.distress.rows;
                    })
                    .catch(({ response }) => {
                        console.log(response.status.errors);
                    });
            });
            if (this.addDistressImage) {
                this.checked = true;
            }
        }
    }
};
</script>

<style>
/* .marign_color {
    margin: 2px;
    border: 1px solid rgb(73, 70, 70);
} */

/* .marign_color:hover {
    border: 2px solid black;
    margin: 0px;
} */

/* .selected_color {
    border: 2px solid black;
    margin: 0px;
} */

.design_studio_tool .ui-palette-box.present_color .marign_color.selected_color {
    border: 1px solid #0079c1 !important;
}

.design_studio_tool
    .ui-palette-box.present_color
    .marign_color.selected_color:after {
    content: "";
    width: 33px;
    display: block;
    background: #0079c1;
    height: 2px;
    position: absolute;
    bottom: -23px;
    z-index: 9;
}
</style>
